import React from "react";
import { Box, Stack, Typography, Chip } from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { PALETTE, ApprovalRow } from "../types";

// Reads directly from the approval row. `phaseName` is the CURRENT
// phase the target sits in (snapshot at gate time). `requestedNextStatus`
// is either the destination phase name (transition) or a target status
// (e.g. "Mastered", "Closed"). No client-side re-derivation of destination.
const MasteryProgression: React.FC<{ row: ApprovalRow; compact?: boolean }> = ({ row, compact }) => {
  const arrow = <ArrowForwardOutlinedIcon sx={{ fontSize: 16, color: PALETTE.slate }} />;
  const size = compact ? 11.5 : 12.5;
  const pad = compact ? 0.75 : 1;
  const chip = (label: string, active: boolean, tone: string) => (
    <Chip
      size="small"
      label={label}
      sx={{
        fontSize: size, fontWeight: 800, letterSpacing: "0.02em",
        bgcolor: active ? tone : "#f1f5f9",
        color: active ? "#fff" : PALETTE.slate,
        border: `1px solid ${active ? tone : PALETTE.border}`,
        px: pad, height: compact ? 22 : 26,
      }}
    />
  );

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ flexWrap: "wrap" }}>
      {chip(row.phaseName || "Current", true, PALETTE.navy)}
      <Box sx={{ display: "inline-flex" }}>{arrow}</Box>
      {chip(row.requestedNextStatus || "Next", true, row.requestedOutcome === "status" ? PALETTE.approved.accent : PALETTE.info.accent)}
      {row.requestedOutcome === "status" && (
        <Typography sx={{ fontSize: 10.5, color: PALETTE.slate, fontStyle: "italic", ml: 0.5 }}>
          (target status)
        </Typography>
      )}
    </Stack>
  );
};

export default MasteryProgression;
